<template>
	<div class="main-wrapper">
		<layout-header></layout-header>
		<layout-sidebar></layout-sidebar>

		<!-- Page Wrapper -->
		<div class="page-wrapper">
			<div class="content container-fluid">
				<div class="page-header">
					<div class="content-page-header">
						<h5>Estimates</h5>
						<div class="list-btn">
							<ul class="filter-list">
								<li>
									<a class="btn-filters w-auto popup-toggle"
										><span><i class="feather feather-filter"></i></span>
									</a>
								</li>
								<li>
									<a
										@click="openModal(null, 'export')"
										class="btn-filters w-auto"
										href="javascript:void(0);"
										><span><i class="feather feather-download-cloud"></i></span>
									</a>
								</li>
								<li>
									<router-link class="btn btn-primary" to="/add-estimate"
										><i class="fa fa-plus-circle me-2" aria-hidden="true"></i>Add
										Estimate</router-link
									>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<!-- /Page Header -->

				<!-- Add Asset -->
				<div class="toggle-sidebar">
					<div class="sidebar-layout-filter">
						<div class="sidebar-header">
							<h5>Filter</h5>
							<a href="javascript:;" class="sidebar-closes"
								><i class="fa-regular fa-circle-xmark"></i
							></a>
						</div>
						<div class="sidebar-body">
							<b-form action="#" autocomplete="off">
								<!-- Estimates -->
								<div class="accordion" id="accordionMain1">
									<a
										href="javascript:void(0);"
										class="w-100"
										data-bs-toggle="collapse"
										data-bs-target="#collapseOne"
										aria-expanded="true"
										aria-controls="collapseOne"
									>
										<div class="card-header-new" id="headingOne">
											<h6 class="filter-title">
												Estimates
												<span class="float-end"
													><i class="fa-solid fa-chevron-down"></i
												></span>
											</h6>
										</div>
									</a>

									<div
										id="collapseOne"
										class="collapse show"
										aria-labelledby="headingOne"
										data-bs-parent="#accordionExample1"
									>
										<div class="card-body-chat">
											<div class="row">
												<div class="col-md-12">
													<div id="checkBoxes1">
														<div class="form-custom">
															<input
																type="text"
																class="form-control"
																v-model="searchForm.search"
																id="member_search1"
																placeholder="Search here"
															/>
															<span
																><img src="@/assets/img/icons/search.svg" alt="img"
															/></span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- /Customer -->

								<!-- Select Date -->
								<div class="accordion" id="accordionMain2">
									<a
										href="javascript:void(0);"
										class="w-100 collapsed"
										data-bs-toggle="collapse"
										data-bs-target="#collapseTwo"
										aria-expanded="true"
										aria-controls="collapseTwo"
									>
										<div class="card-header-new" id="headingTwo">
											<h6 class="filter-title">
												Select Date
												<span class="float-end"
													><i class="fa-solid fa-chevron-down"></i
												></span>
											</h6>
										</div>
									</a>

									<div
										id="collapseTwo"
										class="collapse"
										aria-labelledby="headingTwo"
										data-bs-parent="#accordionExample2"
									>
										<div class="card-body-chat">
											<div class="form-group">
												<label class="form-control-label">From</label>
												<div class="cal-icon">
													<datepicker
														v-model="searchForm.from"
														class="picker"
														:editable="true"
														:clearable="false"
													/>
												</div>
											</div>
											<div class="form-group">
												<label class="form-control-label">To</label>
												<div class="cal-icon">
													<datepicker
														v-model="searchForm.to"
														class="picker"
														:editable="true"
														:clearable="false"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- /Select Date -->

								<!-- Category -->
								<div class="accordion accordion-last" id="accordionMain4">
									<a
										href="javascript:void(0);"
										class="w-100"
										data-bs-toggle="collapse"
										data-bs-target="#collapseFour"
										aria-expanded="true"
										aria-controls="collapseFour"
									>
										<div class="card-header-new" id="headingFour">
											<h6 class="filter-title">
												Status
												<span class="float-end"
													><i class="fa-solid fa-chevron-down"></i
												></span>
											</h6>
										</div>
									</a>

									<div
										id="collapseFour"
										class="collapse show"
										aria-labelledby="headingFour"
										data-bs-parent="#accordionExample4"
									>
										<div class="card-body-chat">
											<div id="checkBoxes1">
												<div class="form-custom">
													<b-form-select
														class="search-select"
														v-model="searchForm.status"
														:options="statusOptions"
													></b-form-select>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- /Category -->

								<button
									@click="resetSearchForm"
									class="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
								>
									<span><i class="feather feather-refresh-ccw me-2"></i></span>Reset
								</button>
							</b-form>
						</div>
					</div>
				</div>
				<!--/Add Asset -->

				<div class="row">
					        <div class="col-md-3 mb-3">
                
          <div class="form-custom">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search anything..."
             		v-model="searchForm.search"
            />
        
          </div>
        </div>
												
										
					<div class="col-sm-12">
						<div class="card-table">
							<div class="card-body">
								<div class="table-responsive">
									<a-table
										class="stripped table-hover"
										:columns="columns"
										:loading="isFetching"
										:data-source="estimates.data"
										:pagination="false"
									>
										<template #bodyCell="{ column, record, index }">
											<template v-if="column.key === 'index'">
												<span>{{ index + 1 }}</span>
											</template>
											<template v-else-if="column.key === 'estimate_id'">
												<router-link
													style="color: #878a99"
													:to="`/view-estimate/` + record.id"
												>
													{{ record.estimate_id }}
												</router-link>
											</template>
											<template v-else-if="column.key === 'customer'">
												<router-link
													style="color: #878a99"
													:to="`/customer-details/` + record.customer.id"
												>
													{{ record.customer.name }}
												</router-link>
											</template>
											<template v-else-if="column.key === 'date'">
												{{ formatted(record.date) }}
											</template>
											<template v-else-if="column.key === 'due_date'">
												{{ formatted(record.due_date) }}
											</template>
											<template v-else-if="column.key === 'total_amount'">
												<span
													>{{ record?.currency?.slice(0, 3) }}
													{{ addCurrencyComma(record.total_amount) }}</span
												>
											</template>
											<template v-else-if="column.key === 'status'">
												<span
													class="badge bg-success-light text-success-light text-capitalize"
													v-if="
                            record.status === 'paid' ||
                            record.status === 'refunded' ||
                            record.status === 'sent' ||
                            record.status === 'viewed' ||
                            record.status === 'accepted'
                          "
													>{{ record.status }}</span
												>
												<span
													class="badge bg-warning-light text-warning-light text-capitalize"
													v-else-if="
                            record.status === 'draft' ||
                            record.status === 'pending' ||
                            record.status === 'unpaid' ||
                            record.status === 'recurring'
                          "
													>{{ record.status }}</span
												>
												<span
													class="badge bg-warning-light text-warning-light text-capitalize"
													v-else-if="record.status === 'partially_paid'"
													>Partially paid</span
												>
												<span
													class="badge bg-danger-light text-capitalize"
													v-else-if="
                            record.status === 'expired' ||
                            record.status === 'rejected' ||
                            record.status === 'overdue'
                          "
													>{{ record.status }}</span
												>
											</template>
											<template v-if="column.key === 'action'">
												<div class="d-flex align-items-center justify-content-start">
													<div class="dropdown dropdown-action">
														<a
															href="javascript:;"
															class="btn-action-icon"
															data-bs-toggle="dropdown"
															aria-expanded="false"
															>Action</a
														>
														<div class="dropdown-menu dropdown-menu-end">
															<ul>
																<li>
																	<router-link
																		class="dropdown-item"
																		:to="`/view-estimate/` + record.id"
																		><i class="far fa-eye me-2"></i>View</router-link
																	>
																</li>
																<li>
																	<router-link
																		class="dropdown-item"
																		:to="`/edit-estimate/` + record.id"
																		><i class="far fa-edit me-2"></i>Edit</router-link
																	>
																</li>
																<li>
																	<a
																		class="dropdown-item"
																		href="javascript:void(0);"
																		@click="openModal(record, 'send')"
																		><i class="fa fa-bolt text-success me-2"></i>Send</a
																	>
																</li>
																<li>
																	<a
																		class="dropdown-item"
																		href="javascript:void(0);"
																		@click="openModal(record, 'delete')"
																		><i class="far fa-trash-alt text-danger me-2"></i>Delete</a
																	>
																</li>
																<li>
																	<a
																		class="dropdown-item"
																		@click="openModal(record, 'duplicate')"
																		><i class="far fa-clone me-2"></i>Duplicate</a
																	>
																</li>
																<li
																	v-if="
                                    record.status == 'sent' ||
                                    record.status == 'viewed' ||
                                    record.status == 'draft'
                                  "
																>
																	<a class="dropdown-item" @click="openModal(record, 'accept')"
																		><i class="fa fa-check-circle text-success me-2"></i>Mark as
																		Accepted</a
																	>
																</li>
																<li
																	v-if="
                                    record.status == 'sent' ||
                                    record.status == 'viewed' ||
                                    record.status == 'draft'
                                  "
																>
																	<a class="dropdown-item" @click="openModal(record, 'reject')"
																		><i class="fa fa-times-circle text-danger me-2"></i>Mark as
																		Rejected</a
																	>
																</li>
																<li>
																	<a class="dropdown-item" @click="openModal(record, 'convert')"
																		><i class="feather feather-repeat me-2"></i>Convert to
																		invoice</a
																	>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</template>
										</template>
									</a-table>
								</div>
								<div class="d-flex justify-content-end">
									<a-pagination
										class="mt-4"
										:current="currentPage"
										:total="total"
										:page-size="perPage"
										:show-size-changer="false"
										:show-quick-jumper="false"
										@change="handlePageChange"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Page Wrapper -->
	</div>

	<!-- Delete Expense Modal -->
	<div class="modal custom-fade fade" id="delete_modal" role="dialog">
		<div class="modal-dialog modal-dialog-centered modal-md">
			<div class="modal-content">
				<div class="modal-body">
					<div class="form-header">
						<h3>
							<span v-if="selectedAction === 'delete'">Delete Estimate</span>
							<span v-if="selectedAction === 'send'">Send Estimate</span>
							<span v-if="selectedAction === 'duplicate'">Duplicate Estimate</span>
							<span v-if="selectedAction === 'reject'">Reject Estimate</span>
							<span v-if="selectedAction === 'accept'">Accept Estimate</span>
							<span v-if="selectedAction === 'export'">Export Estimate</span>
							<span v-if="selectedAction === 'convert'">Convert Estimate</span>
						</h3>
						<p v-if="selectedItem">
							Are you sure want to
							<span v-if="selectedAction === 'delete'">delete</span>
							<span v-if="selectedAction === 'send'">send</span>
							<span v-if="selectedAction === 'duplicate'">duplicate</span>
							<span v-if="selectedAction === 'reject'">reject</span>
							<span v-if="selectedAction === 'accept'">accept</span>
							<span v-if="selectedAction === 'convert'">convert</span>

							<span  v-if="selectedAction === 'accept' || selectedAction === 'reject'">
								this
							</span>
							<span v-else class="fw-semibold ms-1">{{
                `${selectedItem.customer.name}`
							}}</span>
							Estimate?
						</p>
						<p v-if="selectedItem === null">
							Are you sure want to
							<span v-if="selectedAction === 'export'">export</span> Estimates?
						</p>
					</div>
					<div class="modal-btn delete-action">
						<div class="row d-flex flex-column align-items-center">
							<div class="col-6 mb-2">
								<button
									v-if="selectedAction === 'delete'"
									@click="deleteEstimate"
									class="w-100 btn btn-primary"
									:disabled="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm me-1"
										role="status"
										aria-hidden="true"
									></span>
									<span v-if="!isLoading">Delete</span>
									<span v-if="isLoading">Deleting...</span>
								</button>
								<button
									v-if="selectedAction === 'send'"
									@click="sendEstimate"
									class="w-100 btn btn-primary"
									:disabled="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm me-1"
										role="status"
										aria-hidden="true"
									></span>
									<span v-if="!isLoading">Send</span>
									<span v-if="isLoading">Sending...</span>
								</button>
								<button
									v-if="selectedAction === 'reject'"
									@click="markAs('rejected')"
									class="w-100 btn btn-primary"
									:disabled="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm me-1"
										role="status"
										aria-hidden="true"
									></span>
									<span v-if="!isLoading">Reject</span>
									<span v-if="isLoading">Rejecting...</span>
								</button>
								<button
									v-if="selectedAction === 'accept'"
									@click="markAs('accepted')"
									class="w-100 btn btn-primary"
									:disabled="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm me-1"
										role="status"
										aria-hidden="true"
									></span>
									<span v-if="!isLoading">Accept</span>
									<span v-if="isLoading">Accepting...</span>
								</button>
								<button
									v-if="selectedAction === 'duplicate'"
									@click="duplicateEstimate"
									class="w-100 btn btn-primary"
									:disabled="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm me-1"
										role="status"
										aria-hidden="true"
									></span>
									<span v-if="!isLoading">Duplicate</span>
									<span v-if="isLoading">Duplicating...</span>
								</button>
								<button
									v-if="selectedAction === 'export'"
									@click="exportEstimate"
									class="w-100 btn btn-primary"
									:disabled="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm me-1"
										role="status"
										aria-hidden="true"
									></span>
									<span v-if="!isLoading">Export</span>
									<span v-if="isLoading">Exporting...</span>
								</button>
								<button
									v-if="selectedAction === 'convert'"
									class="w-100 btn btn-primary"
									@click="convertToInvoice()"
									:disabled="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm me-1"
										role="status"
										aria-hidden="true"
									></span>
									<span v-if="!isLoading">Convert</span>
									<span v-if="isLoading">Converting...</span>
								</button>
							</div>
							<div class="col-6">
								<button
									type="submit"
									data-bs-dismiss="modal"
									class="w-100 btn btn-primary paid-cancel-btn"
								>
									Cancel
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- Delete Expense Modal -->
</template>

<script setup>
import { computed, ref, onMounted, watch } from "vue";
import { formatted, formatDateToDashDigits } from "@/assets/composables/date";
import { addCurrencyComma } from "@/assets/composables/currency";
import { useStore } from "vuex";
import { Modal } from "bootstrap";

const store = useStore();
const isFetching = ref(false);
const currentPage = ref(1);
const perPage = ref(50);
const selectedItem = ref(null);
const selectedAction = ref(null);
const modalInstance = ref(null);
const isLoading = ref(false);

const resetSearchForm = () => {
  searchForm.value = {
    search: "",
    status: "",
    from: "",
    to: "",
  };
};

const searchForm = ref({
  search: "",
  status: "",
  from: "",
  to: "",
});

watch(
  () => searchForm.value,
  (newValue) => {
    isFetching.value = true;
    let data = {
      current_page: currentPage.value,
      per_page: perPage.value,
      query: newValue.search,
      filter: {
        date: {
          mode: "range",
          range: {
            from:
              newValue.from != "" ? formatDateToDashDigits(newValue.from) : "",
            to: newValue.to != "" ? formatDateToDashDigits(newValue.to) : "",
          },
        },
      },
    };
    if (newValue.status != "") {
      data.filter.status = [newValue.status];
    }
    store.dispatch("estimate/getEstimates", data).then(() => {
      isFetching.value = false;
    });
  },
  { deep: true }
);

const handlePageChange = (page) => {
  currentPage.value = page;
};

watch(currentPage, (newValue) => {
  currentPage.value = newValue;
  getEstimates();
});

const statusOptions = [
  { value: "", text: "Please select status" },
  { value: "draft", text: "Draft" },
  { value: "pending", text: "Pending" },
  { value: "accepted", text: "Accepted" },
  { value: "rejected", text: "Rejected" },
];

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Estimate ID",
    key: "estimate_id",
    sorter: true,
  },
  {
    title: "Customer",
    key: "customer",
    sorter: true,
  },
  {
    title: "Date Created",
    key: "date",
    sorter: true,
  },
  {
    title: "Expiry Date",
    key: "due_date",
    sorter: true,
  },
  {
    title: "Amount",
    key: "total_amount",
    sorter: true,
  },
  {
    title: "Status",
    key: "status",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const openModal = (estimate, name) => {
  isLoading.value = false;
  selectedAction.value = name;
  selectedItem.value = estimate;
  modalInstance.value.show();
};
const closeModal = () => {
  modalInstance.value.hide();
};

const estimates = computed(() => {
  return store.getters["estimate/estimates"];
});
const total = computed(() => {
  return store.getters["estimate/total"];
});

const getEstimates = () => {
  isFetching.value = true;
  let data = {
    current_page: currentPage.value,
    per_page: perPage.value,
  };
  store
    .dispatch("estimate/getEstimates", data)
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};
const duplicateEstimate = () => {
  isLoading.value = true;
  store
    .dispatch("estimate/duplicateEstimate", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getEstimates();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};
const deleteEstimate = () => {
  isLoading.value = true;
  store
    .dispatch("estimate/deleteEstimate", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const sendEstimate = () => {
  isLoading.value = true;
  store
    .dispatch("estimate/sendEstimate", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getEstimates();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const convertToInvoice = () => {
  isLoading.value = true;
  store
    .dispatch("estimate/convertToInvoice", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getEstimates();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const markAs = (action) => {
  isLoading.value = true;
  let data = {
    id: selectedItem.value.id,
    payload: {
      status: action,
    },
  };

  store
    .dispatch("estimate/markAs", data)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getEstimates();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const exportEstimate = async () => {
  isLoading.value = true;
  await store
    .dispatch("estimate/exportEstimate")
    .then(() => {
      saveExcel(store.state.estimate.url);
    })
    .then(() => {
      closeModal();
      isLoading.value = false;
    })
    .catch(() => {
      closeModal();
      isLoading.value = false;
    });
};

const saveExcel = (fileUrl) => {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.setAttribute("download", "fileName");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

onMounted(() => {
  getEstimates();
  if (document.querySelectorAll(".popup-toggle").length > 0) {
    document.querySelectorAll(".popup-toggle").forEach(function (el) {
      el.addEventListener("click", function () {
        document.querySelector(".toggle-sidebar").classList.add("open-filter");
      });
    });

    document.querySelectorAll(".sidebar-closes").forEach(function (el) {
      el.addEventListener("click", function () {
        document
          .querySelector(".toggle-sidebar")
          .classList.remove("open-filter");
      });
    });
  }

  // Initiate modal
  modalInstance.value = new Modal(document.getElementById("delete_modal"), {
    backdrop: "static",
    keyboard: false,
  });
});
</script>
